<template>
  <Wrapper>
    <Topo
      v-if="$vuetify.breakpoint.mdAndUp"
      logado
    />
    <MenuLateral v-if="$vuetify.breakpoint.mdAndUp" />
    <InternaMain
      class="paddingBottom"
      maxwidth-container="820px"
    >
      <TopoModal
        v-if="$vuetify.breakpoint.smAndDown"
        :url-btn-fechar="urlVoltar"
        :titulo-modal="dadosCompra.produto"
      />

      <v-breadcrumbs
        v-if="$vuetify.breakpoint.mdAndUp"
        :items="migalhaDePao"
        class="pl-0 mt-6"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.href"
            :disabled="item.disabled"
            class="body-2"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>

      <TituloPagina
        :titulo="tituloPagina"
        class="mt-4"
      />

      <p
        class="pa-0 mt-6 mb-0 primary--text"
        data-cy="texto_da_pagina"
      >
        Sua atual forma de pagamento é
        <strong>
          {{ formaPagamento }}.
        </strong>
        Você pode altera-la selecionando uma das opções abaixo:
      </p>

      <v-list
        class="transparent mt-3 py-0 pb-5"
        data-cy="lista_mudar_forma_pagamento"
      >
        <v-list-item
          data-cy="pagamento_credito"
          class="pa-0 mt-1"
        >
          <v-list-item-title
            class="px-0 py-3 text-wrap"
          >
            Cartão de crédito
            <template>
              <span
                v-if="!loadingCartao"
                class="grey--text pl-2 body-2"
              >
                {{ finalCartao() }}
              </span>
              <v-icon
                v-else
                small
                class="grey--text ml-2"
              >
                fas fa-circle-notch fa-spin
              </v-icon>
            </template>
          </v-list-item-title>

          <v-list-item-icon class="my-auto">
            <v-switch
              v-model="formaPagamentoCredito"
              color="primary"
              inset
              dense
              data-cy="switch_credito"
              :disabled="switchDisabled"
              :loading="switchLoading"
              :readonly="formaPagamentoCredito"
              @change="trocarFormaPagamento('credit_card')"
            />
          </v-list-item-icon>
        </v-list-item>
        <v-divider />

        <v-list-item
          data-cy="pagamento_boleto"
          class="pa-0 mt-1"
        >
          <v-list-item-title
            class="px-0 py-3 text-wrap"
          >
            Boleto
          </v-list-item-title>

          <v-list-item-icon class="my-auto">
            <v-switch
              v-model="formaPagamentoBoleto"
              color="primary"
              inset
              dense
              data-cy="switch_boleto"
              :disabled="switchDisabled"
              :loading="switchLoading"
              :readonly="formaPagamentoBoleto"
              @change="trocarFormaPagamento('boleto')"
            />
          </v-list-item-icon>
        </v-list-item>
        <v-divider />
      </v-list>

      <v-alert
        v-if="exibirAlerta"
        color="info"
        dark
        class="mb-5"
        data-cy="alerta_troca_pagamento"
      >
        <template>
          A data da cobrança para o próximo
          <strong>
            {{ formaPagamento }}
          </strong>
          é a mesma informada no resumo da assinatura:
          <br><br>
          Próxima cobrança:
          {{ dadosCompra.valorProximaCobranca | moeda(dadosCompra.currency_symbol) }}
          ({{ dadosCompra.dataProximaCobranca | dataFormatada('2-digit', 'numeric') }})
        </template>
      </v-alert>

      <v-alert
        v-if="boletoVencendo"
        color="error"
        dark
        class="mb-5"
        data-cy="alerta_fatura_vencida"
      >
        <template>
          Sua fatura venceu em
          {{ dadosCompra.last_invoice_date | dataFormatada('numeric', 'numeric') }}
        </template>
      </v-alert>

      <BtnVoltar
        v-if="$vuetify.breakpoint.smAndDown"
        :voltar-para="urlVoltar"
      />

      <v-btn
        v-else
        :to="urlVoltar"
        class="mt-9"
        color="primary"
        data-cy="btn_voltar"
        outlined
        width="278"
      >
        Voltar
      </v-btn>

      <ModalTrocaPagamentoBoleto
        v-model="modalTrocaBoleto"
        :data-vencimento="dadosCompra.dataProximaCobranca || ''"
        @resposta="modalTrocaBoleto = false"
        @resposta-sim="enviaParaApi()"
        @resposta-nao="cancelaTroca()"
      />

      <ModalGenerico
        :show-dialog="abrirModalConfirmacao"
        @changeDialog="trocarPagamentoComBoletoVencido($event)"
      >
        <template slot="titulo">
          Data de Cobrança
        </template>
        <template slot="texto">
          <span v-if="boletoVencendo">
            1 - A sua fatura atual venceu em
            {{ dadosCompra.last_invoice_date | dataFormatada('numeric', 'numeric') }},
            portanto o valor da assinatura será cobrado hoje no seu cartão.
          </span>
          <span v-else>
            1 - A nova data de cobrança será A MESMA DO SEU CARTÃO.
          </span>
          <br><br>
          <span>
            2 - Após essa ação NÃO SERÁ POSSÍVEL retornar
            para Boleto como forma de pagamento.
          </span>
          <br><br>
          <span>Tem certeza que deseja prosseguir?</span>
        </template>
        <template slot="btFalse">
          Não
        </template>
        <template slot="btTrue">
          Sim
        </template>
      </ModalGenerico>

      <SnackBar
        :mensage="snackBar.message"
        :snackbar="snackBar.show"
        :button="true"
        :color="snackBar.color"
        :timeout="snackBar.timeout"
        @changeSnackBar="value => this.snackBar.show = value.visible"
      />
    </InternaMain>
  </Wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ApiCompras from '@/api/compras';
import ApiMeuPerfil from '@/api/meuPerfil';

import Wrapper from '@/components/Wrapper.vue';
import InternaMain from '@/components/InternaMain.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import TopoModal from '@/components/Compras/TopoModal.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import BtnVoltar from '@/components/BtnVoltar.vue';
import SnackBar from '@/components/SnackBar.vue';
import Topo from '@/components/Topo.vue';
import ModalTrocaPagamentoBoleto from '@/components/Compras/ModalTrocaPagamentoBoleto.vue';
import ModalGenerico from '@/components/ModalGenerico.vue';
import moment from 'moment';

export default {
  name: 'FormaPagamento',

  components: {
    Wrapper,
    InternaMain,
    TituloPagina,
    TopoModal,
    BtnVoltar,
    SnackBar,
    ModalTrocaPagamentoBoleto,
    Topo,
    MenuLateral,
    ModalGenerico,
  },

  beforeRouteEnter(to, from, next) {
    if (from.name === 'gerenciar-assinatura' || from.name === 'cartoes-credito-cadastrar') {
      return next((vm) => {
        vm.cartaoCadastrado(from.name === 'cartoes-credito-cadastrar');
      });
    }

    const { compraId } = to.params;
    return next(`/minhas-compras/gerenciar-assinatura/${compraId}`);
  },

  props: {
    compraId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      tituloPagina: 'Forma de pagamento',
      formaPagamentoCredito: false,
      formaPagamentoBoleto: false,
      switchDisabled: false,
      switchLoading: false,
      loadingCartao: false,
      cadastrouCartao: false,
      numberCartao: '',
      checkListaCartao: false,
      modalTrocaBoleto: false,
      abrirModalConfirmacao: false,
      statusBoletoVencido: ['aguardando-pagamento', 'cancelada'],
      snackBar: {
        message: '',
        color: 'success',
        timeout: 6000,
        show: false,
      },
      snackBarMensagens: {
        errorPadrao: 'Tente novamente mais tarde.',
        sucessoBoleto: 'Forma de pagamento alterada para boleto.',
        sucessoCartao: 'Forma de pagamento alterada para cartão.',
      },
    };
  },

  computed: {
    ...mapState(['dadosCompra', 'alertaFormaPagamento']),

    urlVoltar() {
      return `/minhas-compras/gerenciar-assinatura/${this.compraId}`;
    },

    isBoleto() {
      if (this.dadosCompra.membership_is_boleto) return true;
      return false;
    },

    isCredito() {
      return !this.isBoleto;
    },

    formaPagamento() {
      return this.isBoleto ? 'boleto' : 'cartão de crédito';
    },

    exibirAlerta() {
      if (this.alertaFormaPagamento && this.formaPagamento === 'boleto') {
        const encontrado = this.alertaFormaPagamento.find(elemento => elemento === this.compraId);
        return !!encontrado;
      }

      return false;
    },

    diasParaVencimento() {
      return moment(this.dadosCompra.dataProximaCobranca).diff(moment(), 'days');
    },

    migalhaDePao() {
      const itens = [
        {
          disabled: false,
          href: this.urlVoltar,
          text: 'Gerenciar assinatura',
        },
        {
          activeClass: '',
          disabled: true,
          text: 'Trocar forma de pagamento',
        },
      ];
      return itens;
    },

    boletoVencendo() {
      const boletoVencido = moment(this.dadosCompra.last_invoice_date).diff(moment(), 'days') < 0;
      const statusAssinatura = this.statusBoletoVencido.includes(this.dadosCompra.status_slug);

      return boletoVencido && statusAssinatura;
    },
  },

  created() {
    this.formaPagamentoAtual();

    if (this.isBoleto) {
      this.loadingCartao = true;
      this.switchDisabled = true;
      this.getListaCartoes();
    }
  },

  methods: {
    ...mapActions('meuperfil', ['setAssinaturaCadastrarCartao']),
    ...mapActions(['setDadosCompra', 'setAlertaFormaPagamento']),

    finalCartao() {
      if (this.isBoleto) return this.numberCartao;
      if (this.isCredito && this.dadosCompra.cardNumber) {
        if (!this.checkListaCartao && this.dadosCompra.cardNumber.length < 1) {
          this.loadingCartao = true;
          this.getListaCartoes();
          return this.numberCartao;
        }
        if (this.checkListaCartao && this.dadosCompra.cardNumber.length < 1) {
          return '';
        }
        return `****${this.dadosCompra.cardNumber[0].card_number}`;
      }

      return '';
    },

    formaPagamentoAtual() {
      this.formaPagamentoCredito = this.isCredito;
      this.formaPagamentoBoleto = this.isBoleto;
    },

    trocarFormaPagamento(pagamento) {
      this.formaPagamentoCredito = (pagamento === 'credit_card');
      this.formaPagamentoBoleto = (pagamento === 'boleto');

      if (this.formaPagamentoCredito && this.finalCartao() === '') {
        this.setAssinaturaCadastrarCartao(true);
        this.$router.push('/meu-perfil/cartoes-credito/cadastrar');
      } else if (this.formaPagamentoCredito) {
        this.abrirModalConfirmacao = true;
      } else {
        this.enviaParaApi();
      }
    },

    enviaParaApi() {
      const formData = {};
      let mensagem = this.formaPagamentoBoleto
        ? this.snackBarMensagens.sucessoBoleto : this.snackBarMensagens.sucessoCartao;

      this.switchDisabled = true;
      this.switchLoading = true;
      formData.payment_method = this.formaPagamentoBoleto ? 'boleto' : 'credit_card';

      ApiCompras.membershipPayment(this.compraId, formData)
        .then(() => {
          this.setSnackbar(mensagem);
          this.gravarNovosValores({
            boleto: this.formaPagamentoBoleto,
            cartaoCredito: this.formaPagamentoCredito,
            membership_is_boleto: this.formaPagamentoBoleto,
          });
          this.abrirAlerta();
          if (this.formaPagamentoBoleto) {
            this.loadingCartao = true;
            this.getListaCartoes();
          }
        })
        .catch((error) => {
          const { data } = error.response;
          mensagem = data.show ? data.error : this.snackBarMensagens.errorPadrao;
          this.setSnackbar(mensagem, 'error');
          this.formaPagamentoAtual();
        })
        .finally(() => {
          this.switchDisabled = false;
          this.switchLoading = false;
          this.abrirModalConfirmacao = false;
        });
    },

    setSnackbar(mensagem, status = 'success', timeout = 6000) {
      this.snackBar.message = mensagem;
      this.snackBar.color = status;
      this.snackBar.timeout = timeout;
      this.snackBar.show = true;
    },

    gravarNovosValores(atualizar) {
      const dados = this.dadosCompra;
      Object.assign(dados, atualizar);
      this.setDadosCompra(dados);
    },

    abrirAlerta() {
      const arrayValores = this.alertaFormaPagamento ? this.alertaFormaPagamento : [];
      arrayValores.push(this.compraId);
      this.setAlertaFormaPagamento(arrayValores);
    },

    getListaCartoes() {
      ApiMeuPerfil.creditCardList()
        .then((response) => {
          this.cartaoPrincipal(response.data);
          if (this.cadastrouCartao && response.data.length > 0) {
            this.formaPagamentoCredito = true;
            this.trocarFormaPagamento('credit_card');
          }
        })
        .catch(() => {
          this.cartaoPrincipal([]);
        })
        .finally(() => {
          this.checkListaCartao = true;
          this.loadingCartao = false;
          this.switchDisabled = false;
        });
    },

    cartaoPrincipal(lista) {
      if (Array.isArray(lista) && lista.length) {
        const filterPrincipal = obj => obj.is_main;
        const principalArray = lista.filter(filterPrincipal);
        const principalObj = principalArray[0];
        this.gravarNovosValores({
          cardNumber: [{
            card_number: principalObj.number,
          }],
        });

        this.numberCartao = `****${principalObj.number}`;
      } else {
        this.numberCartao = '';
      }
    },

    cartaoCadastrado(value) {
      this.cadastrouCartao = value;
    },

    cancelaTroca() {
      this.formaPagamentoCredito = !this.formaPagamentoCredito;
      this.formaPagamentoBoleto = !this.formaPagamentoBoleto;
    },

    trocarPagamentoComBoletoVencido(value) {
      if (value) {
        this.enviaParaApi();
      } else {
        this.cancelaTroca();
        this.abrirModalConfirmacao = false;
      }
    },
  },
};
</script>
